import {Modal, Button as AntdButton, Tag} from "antd";
import dayjs from "dayjs";
import {FontAwesomeIcon} from "~/components";

const nf = (n) => Number(n || 0).toLocaleString('vi-VN');

/**
 * Modal XÁC NHẬN đổi gói — khách chỉ cần bấm xác nhận, KHÔNG điền gì. 3 chế độ:
 *  - Nâng cấp: plan.prorate có giá trị (user đang có gói trả phí còn hạn) → hiện PHÍ BÙ
 *    CHÊNH LỆCH pro-rata thay vì nguyên giá; gói mới áp dụng NGAY, ngày hết hạn giữ nguyên,
 *    hạn mức đã dùng trừ tiếp vào gói mới. Không prorate → đơn nguyên giá, chu kỳ mới.
 *  - renew=true: gia hạn chính gói đang dùng (chu kỳ mới, hạn mức làm mới).
 *  - downgrade=true: HẠ GÓI CÓ LỊCH — không tạo đơn, chỉ lên lịch: gói hiện tại dùng tiếp
 *    tới effectiveAt rồi mới chuyển; huỷ quyết định được bất cứ lúc nào trước đó.
 */
function UpgradeRequestModal({open, plan, renew, downgrade, effectiveAt, submitting, onCancel, onSubmit}) {
	const L = plan?.limits || {};
	const prorate = !renew && !downgrade ? plan?.prorate : null;

	const title = downgrade ? 'Xác nhận hạ gói' : renew ? 'Xác nhận gia hạn gói' : 'Xác nhận đăng ký gói';
	const okLabel = downgrade ? 'Xác nhận hạ gói' : renew ? 'Xác nhận gia hạn' : 'Xác nhận đăng ký';
	const kindTag = downgrade
		? {color: 'orange', label: 'Hạ gói'}
		: renew ? {color: 'blue', label: 'Gia hạn'} : {color: 'purple', label: 'Nâng cấp'};

	return (
		<Modal
			open={open}
			onCancel={onCancel}
			width={440}
			title={
				<span>
					<FontAwesomeIcon icon="fa-light fa-crown" /> {title}
				</span>
			}
			footer={[
				<AntdButton key="cancel" onClick={onCancel}>Huỷ</AntdButton>,
				<AntdButton
					key="ok"
					type="primary"
					danger={downgrade}
					loading={submitting}
					onClick={() => onSubmit && onSubmit()}
					icon={<FontAwesomeIcon icon="fa-light fa-circle-check" />}
				>
					{okLabel}
				</AntdButton>,
			]}
		>
			<div style={{textAlign: 'center', marginBottom: 12}}>
				<div style={{fontSize: 18, fontWeight: 700}}>
					{plan?.name || plan?.slug}
					{' '}<Tag color={kindTag.color}>{kindTag.label}</Tag>
				</div>
				{plan?.description && <div style={{color: '#8c8c8c', fontSize: 13}}>{plan.description}</div>}
				<div style={{fontSize: 26, fontWeight: 700, color: '#dc2626', marginTop: 6}}>
					{prorate ? (
						<>{nf(prorate.amount)}đ<span style={{fontSize: 14, color: '#8c8c8c', fontWeight: 400}}> trả ngay</span></>
					) : plan?.price > 0 ? (
						<>{nf(plan.price)}đ<span style={{fontSize: 14, color: '#8c8c8c', fontWeight: 400}}> / tháng</span></>
					) : (
						'Miễn phí'
					)}
				</div>
				{prorate && (
					<div style={{color: '#8c8c8c', fontSize: 13, marginTop: 2}}>
						= ({nf(prorate.price_diff)}đ chênh lệch giá) × {prorate.days_left}/{prorate.days_total} ngày còn lại
						· giá gói {nf(plan?.price)}đ/tháng từ kỳ sau
					</div>
				)}
			</div>

			<div style={{background: '#f9fafb', borderRadius: 10, padding: '10px 14px', marginBottom: 12}}>
				<div style={{display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0'}}>
					<FontAwesomeIcon icon="fa-light fa-wand-magic-sparkles" style={{color: '#7c3aed'}} />
					<span><strong>{nf(L.ai_token_limit)}</strong> token AI / chu kỳ</span>
				</div>
				<div style={{display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0'}}>
					<FontAwesomeIcon icon="fa-light fa-link" style={{color: '#2563eb'}} />
					<span><strong>{nf(L.url_checks_per_period)}</strong> URL kiểm tra / tuần</span>
				</div>
				<div style={{display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0'}}>
					<FontAwesomeIcon icon="fa-light fa-folder-tree" style={{color: '#059669'}} />
					<span><strong>{nf(L.max_projects)}</strong> dự án · {nf(L.max_urls_per_project)} URL/dự án</span>
				</div>
			</div>

			<div style={{color: '#6b7280', fontSize: 13}}>
				<FontAwesomeIcon icon="fa-light fa-circle-info" style={{marginRight: 6}} />
				{downgrade
					? `Gói hiện tại vẫn dùng được đến hết ${effectiveAt ? dayjs(effectiveAt).format('DD/MM/YYYY') : 'hạn'} rồi mới chuyển sang gói này. Trong thời gian chờ bạn có thể huỷ quyết định hạ gói bất cứ lúc nào.`
					: renew
						? 'Bấm xác nhận để tạo đơn gia hạn — chu kỳ mới bắt đầu và mọi hạn mức được làm mới sau khi thanh toán được duyệt.'
						: prorate
							? 'Gói mới áp dụng NGAY sau khi thanh toán được duyệt — ngày hết hạn giữ nguyên; phần hạn mức đã dùng ở gói cũ được trừ tiếp vào hạn mức gói mới.'
							: 'Bấm xác nhận để tạo đơn đăng ký. Bước tiếp theo bạn sẽ quét mã QR thanh toán; quản trị viên duyệt là gói kích hoạt.'}
			</div>
		</Modal>
	);
}

export default UpgradeRequestModal;
